import { render, staticRenderFns } from "./editaAdminScoreDialog.vue?vue&type=template&id=1ece408a&scoped=true"
import script from "./editaAdminScoreDialog.vue?vue&type=script&lang=js"
export * from "./editaAdminScoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece408a",
  null
  
)

export default component.exports